module.exports = __webpack_public_path__ + "img/1537418384.f6c78743.jpg";